import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1f35ad4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d1f35ad4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f35ad4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f35ad4')) {
      api.createRecord('d1f35ad4', component.options)
    } else {
      api.reload('d1f35ad4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d1f35ad4&scoped=true", function () {
      api.rerender('d1f35ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/iconFrom/index.vue"
export default component.exports